/**
 * API Model
 * "id": "7e690ae5-1d49-4aa7-20ec-08de47732e54",
      "lotId": "b178a01e-552f-472c-33a7-08ddb48bafbd",
      "seq": 1,
      "documentDate": "0001-01-01T00:00:00",
      "buyerApproved": false,
      "builderApproved": false,
      "buyerApprovedDate": null,
      "builderApprovedDate": null,
      "inContract": false,
      "cash": false,
      "total": 0,
      "notes": null,
      "builderReference": {
        "id": "f051ab49-3349-4a5f-9a8c-08de203271db",
        "reference": "123213"
      },
      "addendumType": {
        "id": "96b73a2f-34a0-4921-b446-ed1aa402e41d",
        "name": "INI"
      },
      "products": []
    }
 */

import { S3Document } from './deal-document.models';
import { AddendumOptionTax } from './addendum-state.models';
import { AddendumTypeSummary, BuilderReferenceSummary, ProductUomSummary } from './deal-options.models';
import { TaxCategoryDto } from '@zayan-erp/home-building';

export enum DiscountType {
  Amount = 'edb4a381-a8ff-48f5-9196-73958cee7757',
  Percentage = '4e02679c-8265-4b25-b33c-0f16f3eb76d5'
}

export interface DealOption {
  id: string;
  lotId: string;
  seq: number;
  documentDate: string;
  buyerApproved: boolean;
  builderApproved: boolean;
  buyerApprovedDate: string | null;
  builderApprovedDate: string | null;
  inContract: boolean;
  cash: boolean;
  includeInAps: boolean;
  total: number;
  optionsTotal: number;
  discountsTotal: number;
  taxesTotal: number;
  incentivesTotal: number;
  notes: string | null;
  builderReference: BuilderReferenceSummary;
  addendumType: AddendumTypeSummary;
  products: DealOptionProduct[];
  isCancelled: boolean;
  createdAt: string;
  createdByUserFullName: string | null;
  isLocked: boolean;
}
export interface DealOptionProductAttribute {
  subCategoryAttributeId: string;
  subCategoryAttribute: string;
  subCategoryAttributeValues: Array<DealOptionProductAttributeValues>;
}

export interface DealOptionProductAttributeValues {
  subCategoryAttributeValueId: string;
  subCategoryAttributeValue: string;
}

export interface DealOptionProduct {
  id: string;
  productId: string;
  salesDescription: string | null;
  modelElevationProductsId: string;
  productCode: string;
  productDescription: string;
  notes: string;
  selectedLocationId: string | null;
  locationName: string;
  locationCode: string | null;
  unitPrice: number;
  quantity: number;
  retailCredit: number;
  incentiveAmount: number;
  discountPercentage: number;
  discount: number;
  discountTypeId: DiscountType;
  discountValue: number;
  productTypeId: string | null;
  productTypeName: string | null;
  productClassId: string | null;
  productClassName: string | null;
  taxCategory: TaxCategoryDto | null;
  taxes: AddendumOptionTax[];
  uofm: ProductUomSummary | null;
  lineNumber: number | null;
  attributes: DealOptionProductAttribute[];
  linkedProducts: DealOptionProduct[];
  productImages: productImages[];
  amount: number;
  isCancelled: boolean;
  categoryName?: string;
  subcategoryName?: string;
}

export interface UpdateDealAddendumPayload {
  builderReferenceId: string;
  notes: string;
  inContract: boolean;
  cash: boolean;
  includeInAps: boolean;
}

export interface ProductOption {
  modelElevationProductsId: string;
  productId?: string;
  code: string;
  description: string;
  type: string;
  uom: string;
  unitPrice: number;
}

export interface AddendumOptionsPayload {
  modelElevationProductsId: string;
  selectedLocationId: string;
  unitPrice: number;
  notes?: string;
  attributes: {
    subCategoryAttributeId: string;
    subCategoryAttributeValueId: string;
  }[];
}

export interface AddendumOptionProduct {
  id: string;
  modelElevationProductsId: string;
  productCode: string;
  notes: string;
  selectedLocationId: string | null;
  locationName: string;
  locationCode: string | null;
}

export interface GenerateAddendumPdfRequest {
  addendumIds: string[] | null;
}

export interface productImages {
  id: string;
  document: S3Document;
}
